import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentCard = ({ document, onView, onEdit, onDelete }) => {
  const getTypeIcon = (type) => {
    const icons = {
      INSPECTION: 'FileCheck',
      NOTAIRE: 'FileText',
      CERTIFICAT_LOCALISATION: 'MapPin',
      BAIL: 'FileSignature',
      FACTURE: 'Receipt',
      GARANTIE: 'Shield',
      PERMIS: 'FileCheck',
      AUTRE: 'File'
    };
    return icons[type] || 'File';
  };

  const getTypeLabel = (type) => {
    const labels = {
      INSPECTION: 'Inspection',
      NOTAIRE: 'Contrat notaire',
      CERTIFICAT_LOCALISATION: 'Certificat localisation',
      BAIL: 'Bail',
      FACTURE: 'Facture',
      GARANTIE: 'Garantie',
      PERMIS: 'Permis',
      AUTRE: 'Autre'
    };
    return labels[type] || type;
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-CA', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div style={{
      background: 'var(--color-card)',
      border: '1px solid var(--color-border)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--spacing-md)',
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--spacing-sm)'
    }}>
      <div style={{ display: 'flex', alignItems: 'start', gap: 'var(--spacing-sm)' }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: 'var(--radius-md)',
          background: 'var(--color-primary)/10',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0
        }}>
          <Icon name={getTypeIcon(document?.type)} size={24} color="var(--color-primary)" />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <h3 style={{
            fontFamily: 'var(--font-body)',
            fontSize: '0.875rem',
            fontWeight: 600,
            color: 'var(--color-foreground)',
            margin: 0,
            marginBottom: '4px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}>
            {document?.title}
          </h3>
          <p style={{
            fontFamily: 'var(--font-caption)',
            fontSize: '0.75rem',
            color: 'var(--color-muted-foreground)',
            margin: 0,
            marginBottom: '4px'
          }}>
            {getTypeLabel(document?.type)}
          </p>
          <p style={{
            fontFamily: 'var(--font-caption)',
            fontSize: '0.75rem',
            color: 'var(--color-muted-foreground)',
            margin: 0
          }}>
            {formatDate(document?.created_at)} • {formatFileSize(document?.file_size)}
          </p>
        </div>
      </div>

      {document?.description && (
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '0.875rem',
          color: 'var(--color-foreground)',
          margin: 0,
          marginTop: 'var(--spacing-xs)'
        }}>
          {document.description}
        </p>
      )}

      {document?.tags && document.tags.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: 'var(--spacing-xs)' }}>
          {document.tags.map((tag, idx) => (
            <span key={idx} style={{
              fontFamily: 'var(--font-caption)',
              fontSize: '0.75rem',
              padding: '2px 8px',
              background: 'var(--color-muted)',
              borderRadius: 'var(--radius-sm)',
              color: 'var(--color-foreground)'
            }}>
              {tag}
            </span>
          ))}
        </div>
      )}

      <div style={{ display: 'flex', gap: 'var(--spacing-xs)', marginTop: 'var(--spacing-sm)' }}>
        {document?.url && (
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            onClick={() => onView?.(document)}
            style={{ flex: 1 }}
          >
            Voir
          </Button>
        )}
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          onClick={() => onEdit?.(document)}
        />
        <Button
          variant="outline"
          size="sm"
          iconName="Trash2"
          onClick={() => onDelete?.(document)}
          style={{ color: 'var(--color-destructive)' }}
        />
      </div>
    </div>
  );
};

export default DocumentCard;
